import React, { useEffect, useState } from "react";
import inTainLOgo from "../../img/intainlogo-3.png";
import { ArrowDropDown } from "@mui/icons-material";
// import { Popover, OverlayTrigger } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";
import moon from "../../img/moon-svgrepo-com.svg";
import sun from "../../img/sun-svgrepo-com.svg";
import { Popover } from "antd";
// import IconButton from "@mui/material/IconButton";
// import { Brightness7, Brightness4 } from "@mui/icons-material";
import { MdOutlineMenu, MdClose } from "react-icons/md";
import "./Header.css";

const Header = () => {
  const navigate = useNavigate();
  const type = sessionStorage.getItem("type");
  const [activeMenu, setActiveMenu] = useState(
    sessionStorage.getItem("activeMenu") || "home"
  );
  const [isDarkMode, setIsDarkMode] = useState(
    sessionStorage.getItem("dark-theme") === "dark"
  );
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const isActive = (menu) => (activeMenu === menu ? "active" : "");

  const toggleTheme = () => {
    const newTheme = !isDarkMode;
    setIsDarkMode(newTheme);
    const theme = newTheme ? "dark" : "light";
    document.documentElement.setAttribute("dark-theme", theme);
    sessionStorage.setItem("dark-theme", theme);
  };

  const handleMenuClick = (menu) => {
    setActiveMenu(menu);
    sessionStorage.setItem("activeMenu", menu);
    setIsMobileMenuOpen(false); // Close mobile menu after click

    const routes = {
      home: "/",
      company: "/company",
      resources: "/resource",
      contact: "/contact-us",
      signin: "/signin",
    };

    if (menu === "signin" && type === "user") {
      // Handle sign out
      sessionStorage.removeItem("type");
      navigate("/");
      return;
    }

    if (routes[menu]) {
      navigate(routes[menu]);
    }
  };

  const handleDropdownClick = (id) => {
    if (window.innerWidth <= 768) {
      setOpenDropdown(openDropdown === id ? null : id);
    }
  };

  const renderMobileDropdown = (item) => (
    <>
      <button
        onClick={() => handleDropdownClick(item.id)}
        className={`mobile-dropdown-button ${isActive(item.id)}`}
      >
        <span>{item.label}</span>
        <ArrowDropDown
          className={`arrow-icon ${openDropdown === item.id ? "active" : ""}`}
        />
      </button>
      <div
        className={`dropdown-content ${openDropdown === item.id ? "show" : ""}`}
      >
        {React.cloneElement(item.dropdownContent, {
          className: "mobile-dropdown-list",
        })}
      </div>
    </>
  );

  const renderDesktopDropdown = (item) => (
    <Popover
      content={item.dropdownContent}
      trigger="click"
      placement="bottom"
      overlayClassName="header-popover"
    >
      <button className={isActive(item.id)}>
        {item.label}
        <ArrowDropDown className={`arrow-icon ${isActive(item.id)}`} />
      </button>
    </Popover>
  );

  const menuItems = [
    { id: "home", label: "Home" },
    {
      id: "platform",
      label: "Platform",
      hasDropdown: true,
      dropdownContent: (
        <ul className="popover-list">
          <li>
            <a href="/intain-admin" className="popover-link" onClick={(e) => {
              e.preventDefault();
              setActiveMenu('platform');
              sessionStorage.setItem("activeMenu", "platform");
              navigate('/intain-admin');
            }}>
              INTAIN<span>ADMIN</span>
            </a>
          </li>
          <li>
            <a href="/intain-markets" className="popover-link" onClick={(e) => {
              e.preventDefault();
              setActiveMenu('platform');
              sessionStorage.setItem("activeMenu", "platform");
              navigate('/intain-markets');
            }}>
              INTAIN<span>MARKETS</span>
            </a>
          </li>
          <li>
            <a href="/intain-ai" className="popover-link" onClick={(e) => {
              e.preventDefault();
              setActiveMenu('platform');
              sessionStorage.setItem("activeMenu", "platform");
              navigate('/intain-ai');
            }}>
              INTAIN<span>AI</span>
            </a>
          </li>
          <li>
            <a href="/ida-virtual-assistant" className="popover-link" onClick={(e) => {
              e.preventDefault();
              setActiveMenu('platform');
              sessionStorage.setItem("activeMenu", "platform");
              navigate('/ida-virtual-assistant');
            }}>
              IDA <span>Virtual Analyst</span>
            </a>
          </li>
        </ul>
      ),
    },
    {
      id: "company",
      label: "Company",
      hasDropdown: true,
      dropdownContent: (
        <ul className="popover-list">
          <li>
            <a className="popover-link" onClick={() => {
              setActiveMenu('company');
              sessionStorage.setItem("activeMenu", "company");
              navigate("/company");
            }}>
              About Us
            </a>
          </li>
          <li>
            <a
              className="popover-link"
              onClick={() => {
                setActiveMenu('company');
                sessionStorage.setItem("activeMenu", "company");
                navigate("/company?section=news-events");
              }}
            >
              News and Events
            </a>
          </li>
          <li>
            <a
              className="popover-link"
              onClick={() => {
                setActiveMenu('company');
                sessionStorage.setItem("activeMenu", "company");
                navigate("/company?section=careers");
              }}
            >
              Careers
            </a>
          </li>
        </ul>
      ),
    },
    { id: "resources", label: "Resources" },
    { id: "contact", label: "Contact Us" },
    { id: "signin", label: type === "user" ? "Sign Out" : "Sign In" },
  ];

  return (
    <header className="header">
      <div className="logo">
        <img
          src={inTainLOgo}
          alt="Logo"
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
        />
      </div>

      <button
        className="mobile-menu-toggle"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        aria-label="Toggle menu"
      >
        {isMobileMenuOpen ? <MdClose size={24} /> : <MdOutlineMenu size={24} />}
      </button>

      <nav className={`nav ${isMobileMenuOpen ? "show" : ""}`}>
        <ul>
          {menuItems.map((item) => (
            <li key={item.id} className={item.hasDropdown ? "menu-item" : ""}>
              {item.hasDropdown ? (
                window.innerWidth <= 768 ? (
                  renderMobileDropdown(item)
                ) : (
                  renderDesktopDropdown(item)
                )
              ) : (
                <button
                  className={isActive(item.id)}
                  onClick={() => handleMenuClick(item.id)}
                >
                  {item.label}
                </button>
              )}
            </li>
          ))}

          <li className="theme-toggle">
            <Tooltip
              title={
                isDarkMode ? "Switch to Dark Mode" : "Switch to Light Mode"
              }
            >
              <div className="theme-toggle-wrapper">
                <input
                  type="checkbox"
                  id="darkmode-toggle"
                  checked={isDarkMode}
                  onChange={toggleTheme}
                />
                <label htmlFor="darkmode-toggle" className="darkmode-label">
                  <img src={moon} alt="moon" className="moon" />
                  <img src={sun} alt="sun" className="sun" />
                </label>
              </div>
            </Tooltip>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
